import { Component, OnInit } from '@angular/core';
import swal from "sweetalert2";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {DataFileService} from "../../utils/data-services/data-file.service";
import {DataProduitService} from "../../utils/data-services/dataProduit.service";
import {catchError} from "rxjs/operators";
import {of} from "rxjs";
import {Router} from "@angular/router";

@Component({
  selector: 'app-upload-fichier',
  templateUrl: './upload-fichier.component.html',
  styleUrls: ['./upload-fichier.component.scss']
})
export class UploadFichierComponent implements OnInit {
  isLoading = false;
  productsArray: any;
  uploadedFile: any;
  file = {
    type: '',
    product: 0
  };
  constructor(
    public dataFileService: DataFileService,
    public dataProductService: DataProduitService,
    private router: Router
  ) {}
  ngOnInit(): void {
    this.getProducts();
  }
  getRequiredError(control: FormControl): string {
    return control.hasError('required') ? 'Ce champ est obligatoire' : '';
  }
  getProducts(): void {
    this.dataProductService.getProduit().subscribe(result => {
      this.productsArray = result.records;
    });
  }
  uploadFile(): void {
    if (this.file.type === 'certificate') {
      this.dataFileService.uploadCertificate(this.uploadedFile).subscribe(result => {
        this.router.navigate(['/gestion-fichiers']);
      });
    } else if (this.file.type === 'job') {
      this.dataFileService.uploadPmaj(this.file.product, this.uploadedFile).subscribe(result => {
        this.router.navigate(['/gestion-fichiers']);
      });
    }
  }
  onCancel() {
    this.router.navigate(['/gestion-fichiers']);
  }
  onFileSelected(event: Event, type: string): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;
    const file = input.files[0];
    this.uploadedFile = file;
    const MAX_SIZE = 10 * 1024 * 1024; // 10 Mo
    if (file.size > MAX_SIZE) {
      swal.fire({ title: 'Erreur', text: 'Le fichier dépasse 10 Mo.' });
      input.value = '';
      return;
    }
  }
}
